import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@pwc/pwc-deals-ui';

const CancelButtonLink = ({ dataTestId, ...rest }) => {
  const { t } = useTranslation();
  return (
    <Button
      className="button-link form-cancel-button"
      data-testid={dataTestId || 'cancel-button-bottom'}
      type="button"
      {...rest}
    >
      {t('cancelBtn')}
    </Button>
  );
};

export default CancelButtonLink;
